import React from "react";
import StudyGateBadge from "../../common/StudyGateBadge/StudyGateBadge";
import { normalizeGateCode } from "./isfStudyGateService";
import "./isf.scss";

export default function StudyGateProgressStrip({ studyGateProgress }) {
  const gates = studyGateProgress?.gates || [];
  const currentIndex = studyGateProgress?.currentIndex ?? 0;
  if (!gates.length) return null;

  const visible = gates
    .map((gate, idx) => ({
      gate,
      idx,
      code: normalizeGateCode(gate.code),
      isCurrent: idx === currentIndex,
      isDone: idx < currentIndex,
    }))
    .filter(({ isDone, isCurrent }) => isDone || isCurrent);

  return (
    <div className="isf-study-gate-progress" data-tour="isf-study-gates-progress">
      {visible.map(({ gate, code, isCurrent, isDone }, visibleIdx) => (
        <React.Fragment key={code}>
          {visibleIdx > 0 ? (
            <span className="isf-study-gate-progress__line" aria-hidden="true" />
          ) : null}
          <StudyGateBadge
            code={code}
            label={gate.name}
            compact
            state={isCurrent ? "current" : "done"}
            title={isCurrent ? "Current gate" : `${gate.name} — Completed`}
          />
        </React.Fragment>
      ))}
    </div>
  );
}
